module.exports = __webpack_public_path__ + "static/media/camping-devices-mobile.604513f8.jpg";